import { useState } from 'react';
import { useTexts } from 'utils/useTexts';
import { AssetLinks } from '@assets/assets';
import { Button } from '@components/shared/Button/Button';

interface FinalOfferProductsProps {
  productName: string;
  price: string;
  disabled: boolean;
}

const FinalOfferPage = () => {
  const { t } = useTexts();
  const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const FinalOfferProducts = ({ productName, price, disabled }: FinalOfferProductsProps) => {
    return (
      <div className="iLendingCDX-product-card">
        <div className="iLendingCDX-form-title--small iLendingCDX-line-height">
          {productName}
          <img
            className="iLendingCDX-information-icon"
            src={AssetLinks.information}
            alt=""
          />
          <p className="iLendingCDX-product-price">{price}</p>
        </div>
        <div className="iLendingCDX-image-container">
          {disabled ? (
            <img
              className="iLendingCDX-tick-mark"
              src={AssetLinks.checkGreyWhite}
              alt=""
            />
          ) : (
            <img
              className="iLendingCDX-tick-mark"
              src={AssetLinks.greenTick}
              alt=""
            />
          )}
        </div>
      </div>
    );
  };
  return (
    <div>
      <h1 className="iLendingCDX-form-title">{t('finalOffer.title')}</h1>
      <h1 className="iLendingCDX-form-title3 iLendingCDX-mb-4">{t('finalOffer.checkNewLoan')}</h1>
      <div className="iLendingCDX-new-loan-card iLendingCDX-mb-4">
        <div className="iLendingCDX-star-icon-container"></div>
        <img
          className="iLendingCDX-star-icon"
          src={AssetLinks.star}
          alt=""
        />
        <div className="iLendingCDX-card-title">{t('finalOffer.yourNewLoan')}</div>
        <div className="iLendingCDX-card-content">
          <p className="iLendingCDX-loan-amount">
            <p className="iLendingCDX-card-text">{t('finalOffer.loanAmount')}</p>
            <p className="iLendingCDX-card-amount">$40,000.00</p>
          </p>
          <p className="iLendingCDX-monthly-payment">
            <p className="iLendingCDX-card-text">{t('finalOffer.monthlyPayment')}</p>
            <p className="iLendingCDX-card-amount">$634.96</p>
          </p>
        </div>

        <p className="iLendingCDX-interest-terms">
          <p className="iLendingCDX-card-text">{t('finalOffer.interestAndTerms')}</p>
          <p className="iLendingCDX-card-amount">4.5% APR / 72 Months</p>
        </p>
      </div>
      <div className="iLendingCDX-final-offer-title">{t('finalOffer.newLoanQualifies')}</div>
      <FinalOfferProducts
        productName={t('finalOffer.guaranteedAssetProtection')}
        price="$26/month"
        disabled={false}
      />
      <FinalOfferProducts
        productName={t('finalOffer.vehicleServiceContract')}
        price="$18/month"
        disabled={false}
      />
      <div className="iLendingCDX-final-offer-title">{t('finalOffer.weRecommend')}</div>
      <div className="iLendingCDX-card-text iLendingCDX-mb-4">{t('finalOffer.recommendDescription')}</div>
      <FinalOfferProducts
        productName={t('finalOffer.completeCare')}
        price="$25/month"
        disabled={true}
      />
      <FinalOfferProducts
        productName={t('finalOffer.paintAndFabric')}
        price="$29/month"
        disabled={true}
      />
      <FinalOfferProducts
        productName={t('finalOffer.vehicleRepurchaseProgram')}
        price="$17/month"
        disabled={true}
      />
      <div className="iLendingCDX-final-offer-card iLendingCDX-mb-4">
        <div className="iLendingCDX-final-offer-content">
          <span>{t('finalOffer.newLoanAmount')}</span>
          <span>$590.96/mnth</span>
        </div>
        <div className="iLendingCDX-final-offer-content">
          <span>{t('finalOffer.gap')}</span>
          <span>$26/mnth</span>
        </div>
        <div className="iLendingCDX-final-offer-content">
          <span>{t('finalOffer.vsc')}</span>
          <span>$18/mnth</span>
        </div>
        <div className="iLendingCDX-card-divider"></div>
        <div className="iLendingCDX-total-payment">{t('finalOffer.totalMonthlyPayment')}$634.96</div>
      </div>
      <div className="iLendingCDX-terms-conditions iLendingCDX-mb-6">
        <label
          className={'iLendingCDX-checkbox-container iLendingCDX-input-label'}
          tabIndex={0}
        >
          <input
            type="checkbox"
            className={'iLendingCDX-checkbox'}
            id="final-offer-acknowledge"
            checked={isChecked}
            onChange={handleOnChange}
          />
          <span
            className="iLendingCDX-checkmark"
            aria-hidden="true"
          ></span>
          {t('finalOffer.iAgree')}
          <a
            className="iLendingCDX-final-offer-tnc"
            href=""
            target="_blank"
          >
            {t('finalOffer.termsAndConditions')}
          </a>
        </label>
      </div>
      <Button
        type="submit"
        className="iLendingCDX-button--rounded"
        size="lg"
        disabled={!isChecked}
      >
        {t('finalOffer.continue')}
      </Button>
    </div>
  );
};

export default FinalOfferPage;
